import { lazy } from 'react';
import { authRoles } from 'app/auth';

const SettingsAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: '/apps/settings/income-type',
			component: lazy(() => import('./list/IncomeType'))
		}
	]
};

export default SettingsAppConfig;
